import script from "./classical-layout-with-map.vue?vue&type=script&setup=true&lang=js"
export * from "./classical-layout-with-map.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__